import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateProfileComponent } from 'src/app/components/update-profile/update-profile.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  user_details: any;
  booking_details_storage: any;
  isRescheduled: boolean = false;
  isCancelled: boolean = false;
  latestBookings: any;
  showBtn: boolean = false;
  user: any;
  user_number: any;

  errorMessage: any = "";
  constructor(public dialog: MatDialog, private route: ActivatedRoute,
    private apiService: ApiService, private storage: StorageService, private router: Router, private spinner: NgxSpinnerService, private snackBar: MatSnackBar, private authService: AuthService) {
  }

  // Dialog method
  openDialog(): void {
    const dialogRef = this.dialog.open(UpdateProfileComponent, {
      width: '500px',
      data: { /* Pass data to the dialog if necessary */ }
    });

    dialogRef.afterClosed().subscribe(result => {
      // Handle any actions after the dialog closes, if needed
    });
  }

  // Navigating to booking details page
  applicantBookingDetails(bookingNo: string) {
    this.router.navigate(['/booking-list/booking-details', bookingNo ]);
  }

  // Navigating to booking list
  allBookings() {
    this.router.navigate(['/booking-list']);
  }

  // Function for getting user booking details according to booking or phone no
  getUserBookingDetails(bookingId: any) {
    this.apiService.getBookingDetails(bookingId).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.booking_details_storage = response;
          if(this.booking_details_storage.data) {
            if(this.booking_details_storage.data.length > 3) {
              this.showBtn = true;
            } else {
              this.showBtn = false;
            }
            this.latestBookings = this.booking_details_storage?.data.slice(0, 3);
            // hiding spinner
            this.spinner.hide();
          }else {
            // hiding spinner
            this.spinner.hide();
          }
        }else {
          // this.storage.remove('token');
        }
      },
      error: (err: any) => {
        this.errorMessage = err.error.message;
        setTimeout(() => {
          this.errorMessage = "";
        }, 6000);
        // this.storage.remove('token');
      },
      complete: () => { }
    });
  }

  

  ngOnInit(): void {
    // showing spinner
    this.spinner.show();
    this.user_details = JSON.parse(this.storage.get('user_data') || '[]');
    this.user = this.authService.getUser(); 
    this.user_number = this.user.data.phone;
    this.getUserBookingDetails(this.user.data.phone); 
      // this.booking_details_storage = JSON.parse(this.storage.get('med_participant_booking_details') || '[]');
      

  }
}
